var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0 6h4l3 8.6-7-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M16 6h-4l-3 8.6 7-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M8 15l-3-9h6l-3 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4 5h-4l2-3 2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M16 5h-4l2-3 2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M10 5h-4l2-3 2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.34 2h3.66l-2 3-1.66-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M9 2h4l-2 3-2-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondHeader);
export default __webpack_public_path__ + "static/media/diamondHeader.598e2c784376643e9b24e629b55acd18.svg";
export { ForwardRef as ReactComponent };